import { Catalogue, Solution } from '../types';
import { getCatalogueItemFromCatalogue } from './get-device-from-catalogue';

export function getTitleListFromSolutions(solutions: Solution[], catalogue: Catalogue) {
  return solutions.map((solution) => {
    const catalogueItem = getCatalogueItemFromCatalogue(
      catalogue,
      solution.productId,
      solution.acquiringChannel,
    );

    if (!catalogueItem) {
      return { title: '', image: '', deliveryOptions: undefined };
    }

    return {
      title: catalogueItem.device.title || '',
      image: catalogueItem.device.imageBase64 || '',
      deliveryOptions: catalogueItem.device.deliveryOptions,
      secondaryAcquiringChannel: catalogueItem.device.secondaryAcquiringChannel,
    };
  });
}
